<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageapprovecompany/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
